// extracted by mini-css-extract-plugin
module.exports = {"number":"Choice_number__1rEFH","choice-options":"Choice_choice-options__1ZWV0"};